module.exports = __webpack_public_path__ + "static/FSD-1-HH-85f0ba2d47579308031297a928c827d4.jpg";